const Avatar = (props) => {
  const { customer } = props;
  if (!customer.avatar) {
    return null;
  }
  return (
    <div
      className="c7-avatar"
      style={{ backgroundImage: `url("${customer.avatar}")` }}
    />
  );
};
export default Avatar;
